import { render } from "./VatValidator.vue?vue&type=template&id=6e8d8f5a&ts=true"
import script from "./VatValidator.ts?vue&type=script&lang=ts"
export * from "./VatValidator.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\bms_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__